import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EventType } from '../../types/calendar';
// Using `string` instead of `Date` here because `string` is serializable.
type IsoDate = string

export type CalendarState = {
    eventsList: EventType[]
    iso_date: IsoDate
    selectedEvent?: EventType
}

const initialState: CalendarState = {
    eventsList: [],
    iso_date: (new Date()).toISOString()
};

const calendarSlice = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setEventsList(state: CalendarState, action: PayloadAction<Array<any>>) {
            state.eventsList = action.payload;
        },
        setIsoDate(state: CalendarState, action: PayloadAction<IsoDate>) {
            state.iso_date = action.payload;
        },
    }
});

export default calendarSlice;
